import { AnyAction, Reducer } from 'redux';

export const STORE_NEWPASSWORD = 'forgot/store-newpassword';
export const STORE_CONFIRMPASSWORD = 'forgot/store-confirmpassword';
export const STORE_USERNAME_QUERY = 'usernameQuery/store-usernameQuery';
export const STORE_TYPE_LINK_QUERY = 'type/store-typeoflink';

export interface ForgotPasswordState {
    newpassword?: string;
    confirmpassword?: string;
    userName?: string;
    typeLink?: string;
}

const initialState: ForgotPasswordState = {

};

const reducer: Reducer<ForgotPasswordState> = (state: ForgotPasswordState = initialState, action: AnyAction): ForgotPasswordState => {
    switch (action.type) {
        case STORE_NEWPASSWORD:
            return {
                ...state,
                newpassword: action.newpassword
            };
        case STORE_CONFIRMPASSWORD:
            return {
                ...state,
                confirmpassword: action.confirmpassword
            };
        case STORE_USERNAME_QUERY:
            return {
                ...state,
                userName: action.userName
            };
        case STORE_TYPE_LINK_QUERY:
            return {
                ...state,
                typeLink: action.typeLink
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/forgot.tsx